// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/8fb03ba446f1b76a1d8a.bundle.js";
	if (chunkId === 3) return "static/js/43c64641a4e1a21f90cc.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"63f5ea19ae5774f7e644","139":"1a05ac91ccded58a3d70","140":"5dd6e5d8baf5f3e42111"}[chunkId] + ".chunk.js";
};